import { TableTemplate } from 'types/tableTemplate';

export const paymentMethodTableTemplate: TableTemplate[] = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'name',
    description: 'Nome',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'max_installments',
    description: 'Max. Parcelas',
    originalId: 'max_installments',
    width: 140,
  },
  {
    id: 'type',
    description: 'Tipo',
    originalId: 'type',
    width: 100,
  },
];
